import { isStringNullOrWhiteSpace } from 'owa-localize';
import { isItemOfMessageType } from 'owa-mail-list-store';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import Item from 'owa-service/lib/contract/Item';
import Message from 'owa-service/lib/contract/Message';

export default function getSenderNameForBlockMenuItem(item: Item): string | null {
    const message = isItemOfMessageType(item) ? (item as Message) : null;
    if (message == null) {
        return null;
    }
    const senderMailbox = message.Sender?.Mailbox;
    if (senderMailbox) {
        const name = getNameForBlockMenuItem(senderMailbox);
        if (name) {
            return name;
        }
    }
    const fromMailbox = message.From?.Mailbox;
    if (fromMailbox) {
        const name = getNameForBlockMenuItem(fromMailbox);
        if (name) {
            return name;
        }
    }
    return null;
}

function getNameForBlockMenuItem(mailbox: EmailAddressWrapper): string | null {
    if (mailbox.MailboxType != 'GroupMailbox' && !isStringNullOrWhiteSpace(mailbox.EmailAddress)) {
        return !isStringNullOrWhiteSpace(mailbox.Name) ? mailbox.Name : mailbox.EmailAddress;
    }
    return null;
}
